import { HistoricalData } from './types';

export const HISTORICAL_GOLD_DATA: HistoricalData[] = [
  { year: 1988, city: '卡尔加里', china: 0, germany: 11 },
  { year: 1992, city: '阿尔贝维尔', china: 0, germany: 10 },
  { year: 1994, city: '利勒哈默尔', china: 0, germany: 9 },
  { year: 1998, city: '长野', china: 0, germany: 12 },
  { year: 2002, city: '盐湖城', china: 2, germany: 12 },
  { year: 2006, city: '都灵', china: 2, germany: 11 },
  { year: 2010, city: '温哥华', china: 5, germany: 10 },
  { year: 2014, city: '索契', china: 3, germany: 8 },
  { year: 2018, city: '平昌', china: 1, germany: 14 },
  { year: 2022, city: '北京', china: 9, germany: 12 },
];

export const APP_CONFIG = {
  LS_KEY: 'olympic_guesses_2026',
  /** 防重复提交：按 activityId 存的提交成功标志，用于禁用按钮并展示「提交成功，祝您好运！」 */
  SUBMITTED_KEY_PREFIX: 'olympic_submitted_2026_',
  BG_MUSIC_URL: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3',
  CLICK_SFX: 'https://assets.mixkit.co/active_storage/sfx/2568/2568-preview.mp3',
};

